package pl.decks.personal.components.widgets.ranks

typealias SVGPoint = Pair<Float, Float>

val SVGPoint.x get() = first
val SVGPoint.y get() = second

fun SVGPoint.coordinates(): String = "$x,$y"
